var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('BaseContent',{attrs:{"title":"Your Shows"}},[_c('BaseSection',{attrs:{"padded":""}},[(_vm.showList.length)?_c('ShowGridBlock',{attrs:{"shows":_vm.showList}}):_c('BaseEmptyList',{attrs:{"error":{
                    title: `You are not following any shows.`,
                    paragraph: 'Following shows helps us recommend similar shows.',
                }}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }